// JS to drive search dropdowns.
export default { init };


function init(element) {
  // An id to use as a logical group for the dropdown search.
  // It's used to find expected child elements and data attributes.
  const id              = element.getAttribute('data-id');
  // Text to show in the closed drop when no selection is made.
  const defaultText     = element.querySelector(`#default-text-${id}`).dataset.default;
  const dropdownButton  = element.querySelector(`#dropdown-button-${id}`);
  // Continer for the list of options.
  const dropdownMenu    = element.querySelector(`#dropdown-menu-${id}`);
  // The text container of a selection.
  const dropdownSpan    = element.querySelector(`#pms-code-selection-${id}`);
  // Hidden input.
  const searchInput     = element.querySelector(`#search-input-${id}`);
  // Pre|Post selection value.
  const valueInput      = element.querySelector(`#pms-quick-codes-${id}`);
  // Contains JSON encoded data of PMS Codes.
  const pmsCodesEl      = element.querySelector(`#pms-codes-${id}`);
  const isLiveView      = element.classList.contains('is-liveview');
  let pmsCodeData       = JSON.parse(pmsCodesEl.dataset.codes ?? '[]');

  // Handles click selection of option.
  function setSelection(val) {
    valueInput.value = val || "";
    setSelectedText(dropdownSpan, val, pmsCodeData, defaultText);

    if (isLiveView) {
      valueInput.dispatchEvent(new Event("input", { bubbles: true }));
    }
    close(dropdownMenu);
  }

  // Open a search dropdown.
  dropdownButton.addEventListener('click', () => open(dropdownMenu, searchInput));

  // Add event listener to filter items based on input.
  searchInput.addEventListener('input', () => {
    const searchTerm = searchInput.value.toLowerCase();
    const items = dropdownMenu.querySelectorAll('a');

    items.forEach((item) => {
      const text = item.textContent.toLowerCase();
      if (text.includes(searchTerm)) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
  });

  // Add event listeners for selecting an item from the dropdown.
  element.querySelector(`#pms-code-options-${id}`).addEventListener('click', e => {
    const val = e.target.dataset.value || '';
    if (val) e.preventDefault();

    if (isLiveView) {
      setSelection(val);
    } else {
      window.Inputs.setOtherDescription(val, pmsCodeData);
      setSelection(val);
    }
  });

  // Close on Esc
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      close(dropdownMenu);
    }
  });

  // Set the selected value if exists.
  // Using phx:page-loading-stop to handle late-fetched data in LiveView.
  window.addEventListener("phx:page-loading-stop", (info) => {
    pmsCodeData = JSON.parse(pmsCodesEl.dataset.codes ?? '[]');
    setExistingValue(valueInput, dropdownSpan, pmsCodeData, defaultText);
  });
  window.addEventListener("phx:update", (info) => {
    pmsCodeData = JSON.parse(pmsCodesEl.dataset.codes ?? '[]');
    setExistingValue(valueInput, dropdownSpan, pmsCodeData, defaultText);
  });

  setExistingValue(valueInput, dropdownSpan, pmsCodeData, defaultText);
}

// Selecting existing values after page load.
function setExistingValue(input, span, data, defaultText) {
  if (input.value) {
    setSelectedText(span, input.value, data, defaultText);
  }
}

// Sets the visual selected text.
function setSelectedText(element, id, data, defaultText) {
  const item = data.find(d => d.id == id);
  if (item) {
    element.innerHTML = `${item.id} : ${item.description}`;
    element.classList.remove('text-gray-400');
  } else {
    element.innerHTML = defaultText;
    element.classList.add('text-gray-400');
  }
}

function close(dropdown) {
  if (!dropdown.classList.contains('hidden')) {
    dropdown.classList.add('hidden');
  }
}

function open(dropdown, input) {
  // Sorry everyone. I feel gross about this.
  // But this it to allow LiveView's phx-click-away to fire first.
  setTimeout(() => {
    dropdown.classList.remove('hidden');
    input.focus();
  }, 100);
}
